<template>
	<div class="deliver-history-body">
		<div class="order-detail-header">
			<img src="~/images/icon/position.png" alt="" class="position">
			<div class="my-position">您的位置：</div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>
					<span class="go-back-span" @click="goBack('all')">全部订单</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item>
					<span class="go-back-span" @click="goBack('single')">{{orderStatus}}</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item ><span class="go-back-span" @click="goDetail()">订单详情</span></el-breadcrumb-item>
				<el-breadcrumb-item>历史发货记录</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
<!-- 		<div class="order-detail-header">
			<img src="~/images/icon//back-btn-icon.png" @click="goBack">历史发货记录
		</div> -->
		<div class="filters-container">
			<div style="display: flex;">
				<div class="input-box" style="min-width: 351px">
					<span style="line-height: 32px;width: 60px;flex-shrink: 0">发货时间：</span>
					<el-date-picker
						v-model="dateValue"
						:unlink-panels='true'
						class="time-input"
						size="mini"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
						format='yyyy-MM-dd HH:mm:ss'
						value-format='yyyy-MM-dd HH:mm:ss'>
					</el-date-picker>
				</div>
				<div class="input-box">
					<span>商品名称：</span>
					<el-input
						v-model="goodsName"
						placeholder="请输入商品名称"
						class="name-input"
						size="mini"
						@keyup.enter.native="search"
						></el-input>
				</div>
				<div class="input-box">
					<span>发货方式：</span>
					<el-select v-model="usertype" class="name-input" size='mini'>
						<el-option value="-1" label="全部"></el-option>
						<el-option value="0" label="快递"></el-option>
						<el-option value="1" label="自提"></el-option>
					</el-select>
				</div>
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" @click="clear">清空</el-button>
			</div>
			<div style="display: flex;">
				<div style="display: flex;margin-top: 20px;">
					<div class="input-box">
						<span>物流公司：</span>
						<el-input v-model="companycode" placeholder="请输入快递公司" size="mini" @keyup.enter.native="search" class="name-input">
							<!-- <el-option
								v-for="item in options"
								:key="item.value"
								:label="item.value"
								:value="item.id">
							</el-option> -->
						</el-input>
					</div>
				</div>
				<div style="display: flex;margin-top: 20px;">
					<div class="input-box">
						<span>物流单号：</span>
						<el-input
							v-model="number"
							placeholder="请输入物流单号"
							class="name-input"
							size="mini"
							@keyup.enter.native="search"
							></el-input>
					</div>
				</div>
			</div>
		</div>
		<div class="radio-box">
			<el-radio v-model="searchType" label="0" @change="search">按发货批次</el-radio>
			<el-radio v-model="searchType" label="1" @change="search">按商品</el-radio>
		</div>
		<div class="main-table" v-if="searchType === '0'">
			<div class="main-title-box">
				<div class="main-title1">商品</div>
				<div class="main-title2">单价</div>
				<div class="main-title3">订货量</div>
				<div class="main-title4">订货小计</div>
				<div class="main-title5">实发量</div>
			</div>
			<div class="main-table-box">
				<div class="main-content-box" v-for="item in tableData" :key="item.productid">
					<div class="content-title" v-if="item.sendtype === '快递'">
						<div class="main-title6 bold">
							{{item.ffmpackage}}
						</div>
						<div class="main-title7">
							{{item.senddate}}
						</div>
						<div class="main-title8" v-if="item.companycode || item.number">
							<span v-if="item.companycode">{{item.companycode}}</span><span v-if="item.number">:{{item.number}}</span>
							<i v-if="item.number" class="el-icon-document-copy icon-copy"
							v-clipboard:copy="item.number"
							v-clipboard:success="onCodeCopy"
							v-clipboard:error="onCodeError"/>
						</div>
						<div class="main-title9">
								<el-tooltip class="item" effect="dark" placement="top-start">
									<div slot="content">{{item.buyeraddress}}</div>
									<span class="content">收货地址：{{item.buyeraddress}}</span>
								</el-tooltip>
						</div>
						<div class="main-title10">
							{{item.buyername}} {{item.btel}}
						</div>
						<div class="main-title11">
							操作人：{{item.senduser}}
						</div>
					</div>
					<div class="content-title" v-else>
						<div class="main-title6 bold">
							{{item.ffmpackage}}
						</div>
						<div class="main-title7">
							{{item.senddate}}
						</div>
						<div class="main-title8" :title="item.selfPickLinkName + item.selfPickTel + item.selfPickAddress">
							买家自提 {{item.selfPickLinkName}} {{item.selfPickTel}} {{item.selfPickAddress}}
						</div>
						<div class="main-title9" style="text-align: left;">
							{{item.buyername}} {{item.btel}}
						</div>
						<div class="main-title10">
						</div>
						<div class="main-title11">
							操作人：{{item.senduser}}
						</div>
					</div>
					<div class="content-table" v-for="goodItem in item.productInfos" :key="goodItem.productid">
						<div class="main-content1">
							<div class="goodImg">
								<w-image :src="goodItem.imgurl" alt="" type="product" width="90" height="90"></w-image>
							</div>
							<div class="goodInfo">
								<div class="pname">{{goodItem.pname}}</div>
								<div class="punit">规格：{{goodItem.spec}}</div>
							</div>
						</div>
						<div class="main-content2">
							<div class="text">¥ {{goodItem.price}}</div>
						</div>
						<div class="main-content3">
							<div class="text">× {{goodItem.itemquantity}}</div>
						</div>
						<div class="main-content4">
							<div class="text">¥ {{goodItem.itemmoney}}</div>
						</div>
						<div class="main-content5">
							<div class="text" style="color: #333;">× {{goodItem.sendquantity}}</div>
						</div>
					</div>
					<div class="total-info">
						<div><span>总数：</span>{{item.totalSendQuantity}}</div>
						<div><span>包裹金额：</span>￥{{$fxUtils.toFixedSHW(item.totalSendMoney, 2)}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="main-table" v-else>
			<el-table
				:stripe='true'
				size='mini'
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				style="font-size: 14px;
				color:#333333"
				:header-cell-style="{background:'#F7F8FA', color:'#333333', fontSize:'14px', fontWeight:'bold'}"
				@selection-change="handleSelectionChange">
				<el-table-column
					label="商品"
					width="300"
					align="center">
					<template slot-scope='scope'>
						<div class="shop-info">
							<w-image :src="scope.row.imgurl" alt="" type="product" width="90" height="90"></w-image>
							<div style="margin-left: 15px;
								display: flex;
								flex-flow: column;
								justify-content: space-around;
								align-items: start;"
							><span class="shop-name">{{scope.row.pname}}</span><span class="gray">规格：{{scope.row.spec}}</span></div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="ffmpackage"
					label="包裹名称"
					align="center">
				</el-table-column>
				<el-table-column
					prop="price"
					label="单价"
					align="center">
					<template slot-scope="scope">
						<span class="gray">¥ {{scope.row.initialprice}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="price"
					label="实际单价"
					align="center">
					<template slot-scope="scope">
						<span class="gray">¥ {{scope.row.price}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="itemmoney"
					label="订货小计"
					align="center">
					<template slot-scope="scope">
						<span class="gray">¥ {{scope.row.itemmoney}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="itemquantity"
					label="订货量"
					align="center">
					<template slot-scope="scope">
						<span class="gray">× {{scope.row.itemquantity}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="sendquantity"
					label="实发量"
					align="center">
					<template slot-scope="scope">
						× {{scope.row.sendquantity}}
					</template>
				</el-table-column>
				<el-table-column
					prop="sendtype"
					label="发货方式"
					align="center">
				</el-table-column>
				<el-table-column
					prop="companycode"
					label="物流信息"
					align="center">
					<template slot-scope="scope">
						<!-- <div v-if="scope.row.sendtype === '快递'" class="sendInfo" @click="showDetail(scope.row.ffmid)">{{scope.row.sourceflag === 1 ? scope.row.companyname : scope.row.companycode}} {{scope.row.number}}</div> -->
						<div v-if="scope.row.sendtype === '快递'">{{scope.row.sourceflag === 1 ? scope.row.companyname : scope.row.companycode}} {{scope.row.number}}</div>
						<div v-if="scope.row.sendtype === '自提'" :title="scope.row.selfPickLinkName + scope.row.selfPickTel + scope.row.selfPickAddress">{{scope.row.selfPickLinkName}} {{scope.row.selfPickTel}} {{scope.row.selfPickAddress}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="senduser"
					label="操作人"
					align="center">
				</el-table-column>
				<el-table-column
					prop="senddate"
					label="发货时间"
					align="center"
					min-width="150">
					<template slot-scope='scope'>
						<div class="shop-info" style="display: inline-block;text-align:center;">
							{{scope.row.senddate}}
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog
			title="物流详情"
			:visible.sync="logisticsVisible"
			:close-on-click-modal="false"
			class="dialog-title"
			width="800px">
			<div class="dialog-body">
				<div class="package-status">
					<ul class="status-list">
						<li v-for="(item, index) in expressList" :key="item.time" :class="status === '已签收' && index === 0 ? 'active' : ''">
							<img src="~/images/icon/express-received.jpg" alt="" class="state-img" v-if="status === '已签收' && index === 0">
							<span class="dot" v-else></span>
							<div class="date"><span class="date-state" v-if="status && index === 0">{{status}}</span> {{item.time1}} {{item.time2}}</div>
							<div class="week" v-html="item.contextArr"></div>
							<!-- <div class="week"><span v-for="conItem in item.contextArr" :key="conItem.con" :class="conItem.tel ? 'con-active' : ''">{{conItem.con}}</span></div> -->
						</li>
					</ul>
				</div>
			</div>
		</el-dialog>
		<!-- <el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20,40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination> -->
	</div>
</template>

<script>
export default {
	name: 'deliverManage',
	data () {
		return {
			notActivityFlag: false,
			shopName: '',
			billState: '',
			orderStatus: '',
			afterbillflag: false,
			detailData: '',
			cancelstate: false,
			arriveDate: '',
			arriveDateFlag: 0,
			freight: 0,
			sendCountFlag: 0,
			freightFlag: 0,
			priceFlag: 0,
			goodsItemParams: [],
			goodsSendParams: [],
			backorderdock: 0,
			clddock: 0,
			pushstate: 0,
			tableData: [],
			tableHeight: '100%',
			ids: [],
			number: '',
			personName: '',
			goodsName: '',
			usertype: '-1',
			dateValue: [],
			errorImgUrl: 'this.src="' + require('$assets/images/img/no-goods-img.png') + '"',
			// pagination: {
			// 	page: 1,
			// 	size: 20
			// },
			// totalCount: 0,
			options: [
				{ 'id': '', 'value': '全部' },
				{ 'id': 'shunfeng', 'value': '顺丰' },
				{ 'id': 'yuantong', 'value': '圆通' },
				{ 'id': 'yunda', 'value': '韵达' },
				{ 'id': 'shentong', 'value': '申通' },
				{ 'id': 'huitongkuaidi', 'value': '百世' },
				{ 'id': 'zhongtong', 'value': '中通' },
				{ 'id': 'ems', 'value': 'EMS' },
				{ 'id': 'debangwuliu', 'value': '德邦' },
				{ 'id': 'debangkuaidi', 'value': '德邦快递' },
				{ 'id': 'youzhengbk', 'value': '邮政标准快递' },
				{ 'id': 'zhaijisong', 'value': '宅急送' },
				{ 'id': '0', 'value': '其他' }
			],
			searchType: '1',
			companycode: '',
			expressList: [],
			logisticsVisible: false,
			status: ''
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '6-1')
		let createdate = window.sessionStorage.getItem('createdate')
		let orderInfo = JSON.parse(window.sessionStorage.getItem('orderInfo'))
		this.orderStatus = orderInfo.billState
		if (createdate) {
			// this.dateValue[0] = createdate.substring(0, createdate.length - 3)
			// this.dateValue[1] = this.format((new Date()).getTime())
			this.dateValue[0] = createdate
			this.dateValue[1] = createdate
		} else {
			this.dateValue[0] = ''
			this.dateValue[1] = ''
		}
		this.search()
	},
	destroyed () {
		window.sessionStorage.removeItem('createdate')
	},
	methods: {
		onCodeCopy (e) {
			this.$message.success('复制成功！')
		},
		onCodeError (e) {
			this.$message.error('复制失败！')
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue === []) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于6个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr1[0] === arr2[0]) { // 同年
				if (arr2[1] - arr1[1] > 6) { // 月间隔超过6个月
					flag = false
				} else if (arr2[1] - arr1[1] === 6) { // 月相隔6个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			} else { // 不同年
				if (arr2[0] - arr1[0] > 1) {
					flag = false
				} else if (arr2[0] - arr1[0] === 1) {
					if (arr1[1] + 6 - arr2[1] < 12) { // 月相隔大于6个月
						flag = false
					} else if (arr1[1] + 6 - arr2[1] === 12) { // 月相隔6个月，比较日
						if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
							flag = false
						}
					}
				}
			}
			if (!flag) {
				this.$message.error('时间范围不得超过6个月！')
				return false
			}
			return true
		},
		selectable (row, index) {
			if (row.isAdmin === 1) {
				return false
			} else {
				return true
			}
		},
		handleSelectionChange (val) {
			let a = val
			this.ids = []
			for (let i = 0; i < a.length; i++) {
				this.ids.push(a[i].staffid)
			}
		},
		// handleSizeChange (value) {
		// 	this.pagination.size = value
		// 	this.pagination.page = 1
		// 	this.search()
		// },
		// handlePageChange (value) {
		// 	this.pagination.page = value
		// 	this.search()
		// },
		clear () {
			let createdate = window.sessionStorage.getItem('createdate')
			if (createdate) {
				this.dateValue = [createdate, createdate]
			} else {
				this.dateValue = ['', '']
			}
			// this.dateValue = [window.sessionStorage.getItem('createdate'), this.format((new Date()).getTime())]
			this.goodsName = ''
			this.number = ''
			this.companycode = ''
			this.usertype = '-1'
			this.personName = ''
			this.search()
		},
		goDetail () {
			this.$router.push('/main/orderDetail')
		},
		goBack (mode) {
			let tabParams = JSON.parse(window.sessionStorage.getItem('tabInfo'))
			tabParams.isSellerpull = false
			tabParams.active = this.orderStatus
			if (mode === 'all') {
				tabParams.orderStatus = 8
				tabParams.active = '全部订单'
			} else {
				switch (this.orderStatus) {
				case '待付款':
					tabParams.orderStatus = 0
					break
				case '待接单':
					tabParams.orderStatus = 1
					break
				case '待发货':
					tabParams.orderStatus = 2
					break
				case '备货中':
					tabParams.orderStatus = 2
					tabParams.isSellerpull = true
					break
				case '待收货':
					tabParams.orderStatus = 3
					break
				case '已完成':
					tabParams.orderStatus = 4
					break
				case '已取消':
					tabParams.orderStatus = 5
					break
				}
			}
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabParams))
			this.$router.push('/main/order')
		},
		search (val) {
			if (!this.checkTime()) {
				return false
			}
			let orderParams = JSON.parse(window.sessionStorage.getItem('orderInfo'))
			let oiid = window.sessionStorage.getItem('historyoiid')
			// let createdate = window.sessionStorage.getItem('createdate')
			let startDate = ''
			let endDate = ''
			if (this.dateValue[0] === '') {
				startDate = ''
				endDate = ''
			} else {
				startDate = this.dateValue[0] + ':00'
				endDate = this.dateValue[1] + ':59'
			}
			let params = {
				orderId: orderParams.orderId,
				startDate: startDate,
				endDate: endDate,
				number: this.number,
				sendtype: this.usertype,
				senduser: this.personName,
				pname: this.goodsName,
				oiid: oiid,
				company: this.companycode,
				// page: this.pagination.page,
				// size: this.pagination.size,
				filterType: this.searchType
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findSendInfoOfHistoryNew`,
				data: params
			}).then(res => {
				// if (res.result) {
				// 	res.data.recordList.forEach(item => {
				// 		this.options.forEach(i => {
				// 			if (item.companycode === i.id) {
				// 				item.companycode = i.value
				// 			}
				// 		})
				// 	})
				// 	this.totalCount = res.data.recordCount
				// 	this.tableData = res.data.recordList
				// } else {
				// 	this.$message.error(res.msg)
				// }
				this.tableData = res.recordList
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		add0 (m) { return m < 10 ? '0' + m : m },
		format (shijianchuo) {
			var time = new Date(shijianchuo)
			var y = time.getFullYear()
			var m = time.getMonth() + 1
			var d = time.getDate()
			var h = time.getHours()
			var mm = time.getMinutes()
			// var s = time.getSeconds()
			return y + '-' + this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm)
		},
		showDetail (id) {
			let params = {
				fulfillmentid: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/fulfillment/query`,
				data: params
			}).then(res => {
				if (res.result) {
					let arr = res.data.data
					let status = ''
					switch (res.data.state) {
					case 0:
						status = '在途'
						break
					case 1:
						status = '揽收'
						break
					case 2:
						status = '疑难'
						break
					case 3:
						status = '已签收'
						break
					case 4:
						status = '退签'
						break
					case 5:
						status = '派件中'
						break
					case 6:
						status = '退回'
						break
					case 7:
						status = '转投'
						break
					case 10:
						status = '待清关'
						break
					case 11:
						status = '清关中'
						break
					case 12:
						status = '已清关'
						break
					case 13:
						status = '清关异常'
						break
					case 14:
						status = '拒签'
						break
					}
					this.status = status
					let detailArr = []
					let phoneReg = /1[3456789]\d{9}/g
					let telReg = /\d{3,4}-\d{7,14}/g
					arr.forEach(item => {
						// let curStr = ''
						// let curArr = ''
						let contextArr = item.context
						let time1 = item.time.split(' ')[0].slice(5)
						let time2 = item.time.split(' ')[1].slice(0, 5)
						let phoneArr = item.context.match(phoneReg)
						let telArr = item.context.match(telReg)
						if (phoneArr) {
							phoneArr = [...new Set(phoneArr)]
							for (var i = 0; i < phoneArr.length; i++) {
								var temp = phoneArr[i]
								contextArr = contextArr.replaceAll(phoneArr[i], '<span style="font-weight:bold">' + temp + '</span>')
							}
						}
						if (telArr) {
							telArr = [...new Set(telArr)]
							for (var j = 0; j < telArr.length; j++) {
								var temp1 = telArr[j]
								contextArr = contextArr.replaceAll(telArr[j], '<span style="font-weight:bold">' + temp1 + '</span>')
							}
						}
						// if (phoneArr && telArr) {
						// 	curStr = item.context.split(phoneArr[0]).join('$')
						// 	curStr = curStr.split(telArr[0]).join('$')
						// 	curArr = curStr.split('$')
						// 	curArr.splice(1, 0, phoneArr[0])
						// 	curArr.splice(3, 0, telArr[0])
						// 	contextArr.push(
						// 		{ con: curArr[0], tel: false },
						// 		{ con: curArr[1], tel: true },
						// 		{ con: curArr[2], tel: false },
						// 		{ con: curArr[3], tel: true },
						// 		{ con: curArr[4], tel: false }
						// 	)
						// }
						// if (phoneArr && !telArr) {
						// 	curArr = item.context.split(phoneArr[0])
						// 	curArr.splice(1, 0, phoneArr[0])
						// 	contextArr.push(
						// 		{ con: curArr[0], tel: false },
						// 		{ con: curArr[1], tel: true },
						// 		{ con: curArr[2], tel: false }
						// 	)
						// }
						// if (!phoneArr && telArr) {
						// 	curArr = item.context.split(telArr[0])
						// 	curArr.splice(1, 0, telArr[0])
						// 	contextArr.push(
						// 		{ con: curArr[0], tel: false },
						// 		{ con: curArr[1], tel: true },
						// 		{ con: curArr[2], tel: false }
						// 	)
						// }
						// if (!phoneArr && !telArr) {
						// 	contextArr.push({ con: item.context, tel: false })
						// }
						detailArr.push({ time1, time2, contextArr })
					})
					// console.log(detailArr)
					this.expressList = detailArr
					this.logisticsVisible = true
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.deliver-history-body{
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.shop-info{
		display: flex
		padding: 17px
		img {
			width: 90px
			height: 90px
		}
		.shop-name {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			overflow: hidden;
			text-align: left;
		}
	}
	.gray {
		color: #999999
	}
	.icon-copy {
		color: var(--fx-primary-color);
		margin-left: 5px;
		cursor: pointer
	}
	.order-detail-header {
		height:50px;
		line-height:50px;
		text-align:left
		font-size: 16px;
		// border-bottom 1px solid #DCE1FE
		.my-position {
			font-size: 14px;
			display: inline-block;
			position: relative;
			top: -20px;
		}
		.position {
			width: 15px;
			height: 15px;
			float: left;
			margin: 17px 11px 0 9px;
		}
		.el-breadcrumb {
			display inline-block
			height: 49px
			line-height: 49px
			.go-back-span {
				font-weight: 700
				cursor: pointer
			}
		}
		img {
			height: 40px
			float: right
			margin-top: 4px
			margin-right: 20px
		}
	}
	.order-detail-info {
		.info-btn {
			padding: 15px 0
			text-align left
			.btn {
				width :130px;
				height :35px;
				margin-left :20px;
			}
		}
	}
	.sendInfo:hover {
		color:var(--fx-primary-color);
		text-decoration:underline;
		cursor:pointer;
	}
	.package-status {
		padding: 18px 0 10px;
		max-height: 500px;
		overflow-y: auto;
		.status-list {
			padding: 0 30px;
			list-style: none;
			font-size: 14px;
			color: #595959;
			li {
				padding-bottom: 30px;
				padding-left: 30px
				height: auto;
				border-left: 1px solid #ccc
				position: relative
				&.active {
					color: var(--fx-primary-color)
					.date {
						color: var(--fx-primary-color)
						.date-state {
							color: var(--fx-primary-color)
						}
					}
				}
				.dot {
					background: #CDCDCD;
					width: 8px;
					height: 8px;
					border-radius: 50%;
					position: absolute;
					left: -4px;
				}
				.state-img {
					position: absolute;
					left: -16px;
					width: 32px;
					height: 32px;
					top: -5px;
				}
				.date {
					color: #999;
					line-height: 15px
					.date-state {
						font-size: 16px;
						margin-right: 17px;
						font-weight: bold;
						color: #595959;
					}
				}
				.week {
					margin-top: 10px
				}
				&:last-of-type {
					border: none;
				}
			}
		}
	}
}
</style>
<style lang="stylus">
.deliver-history-body {
	.radio-box {
		display: flex
		padding: 29px 0
	}
	.main-table {
		display flex
		flex: 1
		flex-direction: column
		min-height: 500px
		.main-title-box {
			width: 100%;
			height: 50px;
			line-height: 50px;
			color: #333;
			font-size: 14px;
			font-weight: bold;
			display: flex;
			background-color: #F7F8FA
			div{
				text-align: center
				font-weight: bold
			}
		}
		.main-title1 {
			flex: 2
		}
		.main-title2 {
			flex: 1
		}
		.main-title3 {
			flex: 1
		}
		.main-title4 {
			flex: 1
		}
		.main-title5 {
			flex: 1
		}
		.main-table-box {
			flex: 1
			padding-bottom 10px
			overflow-y: auto;
			.main-content-box {
				width: 100%;
				color: #333;
				font-size: 14px;
				// border: 1px solid #F7F8FA;
				// box-shadow: 0px 2px 4px 1px rgba(199, 199, 199, 0.23);
				box-sizing: border-box;
				border-radius: 2px;
				margin-top: 10px
				overflow: hidden
				.content-title {
					width: 100%
					height: 58px;
					line-height: 60px;
					background-color: #F7F8FA
					display: flex
					.bold {
						font-weight: bold
					}
					.main-title6 {
						flex: 1
					}
					.main-title7 {
						flex: 2
					}
					.main-title8 {
						flex: 2
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						padding-right: 5px
					}
					.main-title9 {
						flex: 3
						overflow: hidden
						white-space: nowrap
						text-overflow: ellipsis
						-webkit-line-clamp: 1
					}
					.main-title10 {
						flex: 2
					}
					.main-title11 {
						flex: 1
					}
				}
				.content-table {
					width: 100%
					display: flex
					border: 1px solid #EDEFFC
					.main-content1 {
						flex: 2
						display: flex
						flex-flow: row
						.goodImg {
							width: 90px
							height: 90px
							background: #FFFFFF
							border: 1px solid #EEEEEE
							margin: 17px
							img {
								width: 90px
								height: 90px
							}
						}
						.goodInfo {
							margin: 17px
							display: flex
							flex-flow: column
							width: 215px
							justify-content: space-around
							align-items: start
							.pname {
								text-align: left;
								overflow: hidden
								text-overflow: ellipsis
								display: -webkit-box
								-webkit-line-clamp: 2
								line-clamp: 2
								-webkit-box-orient: vertical
							}
							.punit {
								font-size: 14px
								font-weight: 400
								color: #999999
							}
						}
					}
					.main-content2
					.main-content3
					.main-content4
					.main-content5{
						flex: 1
						.text {
							flex: 1
							font-size: 14px
							display: flex
							height: 100%
							align-items: center
							justify-content: center
							color: #999999
						}
					}
				}
				.total-info {
					display: flex;
					flex-flow: column;
					align-items: flex-start;
					float: right;
					padding-right: 30px;
					text-align: left
					div {
						margin-top: 15px
						span {
							display: inline-block
							width: 110px
							text-align: right
							padding-right: 10px;
						}
					}
				}
			}
		}
	}
	.el-input__inner{
		padding: 0 5px
	}
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.btn-box {
		display flex
		justify-content: center
		margin-top: 15px
		.el-button {
			width: 120px
		}
	}
	.filters-container {
		display flex
		flex-flow: column
		// flex: 1
		// align-items: center
		height: 80px
		// margin-top: 15px
		.input-box {
			display flex
			// width: 250px
			margin-right: 10px
			span {
				// margin-right: 5px
				line-height: 28px
			}
			.name-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			// margin-top: 14px
			margin-left 20px
		}
	}
}
</style>
